var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"footer-menu list-unstyled"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"footer-menu__item"},[_c('a',{attrs:{"href":item.link,"target":item.target}},[_vm._v(_vm._s(item.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }